import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

import Loader2 from "../../elements/Loader2";
import commoncss from "../../css/common.module.css";
import createRegCss from "../../css/createregister.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router-dom";
import accountant from "../../../../src/assets/signIn.svg";
import ApproverLeaseModal from "../leases/ApproverLeaseModal";
import { useHistory } from "react-router";
import { ReactComponent as DownArrow } from "../../assets/icons/down-arrow.svg";


const EditInvestmentRegister = ({
  companyOptions = [],
  registerData = {},
  onSave,
  onSendForApproval,
}) => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const { registerId } = useParams();

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(registerData?.name || "");
  const [selectedCompanies, setSelectedCompanies] = useState(
    registerData?.linkedCompanies || []
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);
  const [isApprovalPending, setIsApprovalPending] = useState(
    registerData?.approvalStatus?.includes("pending") || false
  );

  const dropdownRef = useRef(null);

  // Sync state if registerData prop changes
  useEffect(() => {
    if (registerData?.name) setRegName(registerData.name);
    if (registerData?.linkedCompanies)
      setSelectedCompanies(registerData.linkedCompanies);
    if (registerData?.approvalStatus)
      setIsApprovalPending(registerData.approvalStatus.includes("pending"));
  }, [registerData]);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSave = () => {
    const payload = {
      id: registerId,
      name: regName,
      linkedCompanies: selectedCompanies.map((c) => c.value),
    };
    if (onSave) onSave(payload);
  };

  const handleSendForApproval = (approverID) => {
    const payload = {
      id: registerId,
      name: regName,
      linkedCompanies: selectedCompanies.map((c) => c.value),
      approvalStatus: "pending approval",
      approverID: approverID,
    };
    if (onSendForApproval) onSendForApproval(payload);
    setApproverLeaseModal(false);
  };

  const isFormValid = regName?.trim() && selectedCompanies.length > 0;

  const breadcrumbItems = [
    {
      label: "Home",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Edit Register",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Investment", link: "", className: "headerLable" },
  ];

  return (
    <>
      <div className="conatiner">
        {loader && <Loader2 />}

        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.imgContainer}
        >
          <img
            src={accountant}
            alt="accountant working"
            style={{ height: "93.7vh", placeSelf: "center" }}
          />
        </motion.div>

        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.formContainer}
        >
          <div className={commoncss.dFlexJustifysb}>
            <Breadcrumb
              style="margin-right:auto"
              items={breadcrumbItems}
              headerActions={<></>}
            />
          </div>

          <motion.div
            initial={{ x: 400, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            <div className={createRegCss.alignForm}>
              <div className={createRegCss.container2}>
                <div className={`${commoncss.dFlex} mb-3`}>
                  <div
                    className={commoncss.dFlexClm}
                    style={{ alignItems: "center" }}
                  >
                    <span className={createRegCss.heading1}>
                      Edit Investment Register
                    </span>
                    <span className={createRegCss.label1}>
                      Edit register name and linked companies
                    </span>
                  </div>
                </div>

                <div className={`${createRegCss.container3} mt-3 mb-1`}>

                  {/* Register Name */}
                  <InputGroup
                    label="Name of Investment Register"
                    inputs={[
                      <input
                        key="reg-name"
                        name="invreg_name"
                        placeholder="Investment register"
                        type="text"
                        value={regName}
                        onChange={(e) => setRegName(e.target.value)}
                        disabled={isApprovalPending}
                      />,
                    ]}
                  />

                  {/* Linked Companies Multi-select */}
                  <InputGroup
                    label="Select Linked Companies"
                    class_="mt-2"
                    inputs={[
                      <div
                        key="company-select"
                        ref={dropdownRef}
                        style={{ position: "relative", width: "100%" }}
                      >
                        {/* Trigger */}
                        <div
                          onClick={() =>
                            !isApprovalPending && setDropdownOpen((o) => !o)
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 12px",
                            border: "1px solid #C2E6D1",
                            borderRadius: "10px",
                            backgroundColor: isApprovalPending ? "#f0f0f0" : "#F4FAF5",
                            cursor: isApprovalPending ? "not-allowed" : "pointer",
                            minHeight: "40px",
                            fontFamily: "DM Sans, sans-serif",
                            fontSize: "13px",
                            color: "#183930",
                          }}
                        >
                          <span
                            style={{
                              color: selectedCompanies.length === 0 ? "#9CA3AF" : "#183930",
                            }}
                          >
                            {selectedCompanies.length === 0
                              ? "Select Companies"
                              : selectedCompanies.map((c) => c.label).join(", ")}
                          </span>
                          {!isApprovalPending && (
                            <DownArrow
                              style={{
                                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.2s",
                              }}
                            />
                          )}
                        </div>

                        {/* Dropdown Options */}
                        {dropdownOpen && !isApprovalPending && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 4px)",
                              left: 0,
                              right: 0,
                              backgroundColor: "#fff",
                              border: "1px solid #C2E6D1",
                              borderRadius: "10px",
                              boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                              zIndex: 999,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {companyOptions.map((opt) => {
                              const selected = !!selectedCompanies.find(
                                (v) => v.value === opt.value
                              );
                              return (
                                <div
                                  key={opt.value}
                                  onClick={() => {
                                    if (selected) {
                                      setSelectedCompanies(
                                        selectedCompanies.filter((v) => v.value !== opt.value)
                                      );
                                    } else {
                                      setSelectedCompanies([...selectedCompanies, opt]);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "9px 14px",
                                    cursor: "pointer",
                                    fontFamily: "DM Sans",
                                    fontSize: "13px",
                                    color: "#205a46",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      borderRadius: "4px",
                                      flexShrink: 0,
                                      border: selected ? "none" : "1.5px solid #C2E6D1",
                                      backgroundColor: selected ? "#183930" : "transparent",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {selected && (
                                      <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                                        <polyline
                                          points="2,6 5,9 10,3"
                                          stroke="#ffffff"
                                          strokeWidth="1.8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    )}
                                  </div>
                                  {opt.label}
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* Chips */}
                        {selectedCompanies.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              marginTop: "10px",
                            }}
                          >
                            {selectedCompanies.map((opt) => (
                              <div
                                key={opt.value}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "8px 10px",
                                  border: "0.8px solid #C2E6D1",
                                  borderRadius: "6px",
                                  backgroundColor: "#fff",
                                  fontFamily: "DM Sans, sans-serif",
                                  fontSize: "13px",
                                  color: "#183930",
                                }}
                              >
                                {opt.label}
                                {!isApprovalPending && (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedCompanies(
                                        selectedCompanies.filter((v) => v.value !== opt.value)
                                      );
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#B3C0BD",
                                    }}
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    >
                                      <line x1="2" y1="2" x2="12" y2="12" />
                                      <line x1="12" y1="2" x2="2" y2="12" />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>,
                    ]}
                  />

                  {/* Action Buttons */}
                  <div
                    className="mt-4"
                    style={{ width: "70%", placeSelf: "center" }}
                  >
                    {user?.isAdmin === "Yes" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !isFormValid ? buttoncss.disabledBtn : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          borderRadius: "12px",
                        }}
                        disabled={!isFormValid}
                        onClick={handleSave}
                      >
                        Save Changes
                      </button>
                    )}

                    {user?.responsibilities === "preparer" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !isFormValid || isApprovalPending
                            ? buttoncss.disabledBtn
                            : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          borderRadius: "12px",
                        }}
                        onClick={() => {
                          if (isFormValid && !isApprovalPending)
                            setApproverLeaseModal(true);
                        }}
                        disabled={!isFormValid || isApprovalPending}
                      >
                        Send changes for approval
                      </button>
                    )}
                  </div>

                  {approverLeaseModal && (
                    <ApproverLeaseModal
                      setApproverLeaseModal={setApproverLeaseModal}
                      companyId={
                        selectedCompanies.length > 0
                          ? selectedCompanies[0].value
                          : null
                      }
                      setApproverId={setApproverId}
                      sendForApproval={handleSendForApproval}
                    />
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </>
  );
};

export default EditInvestmentRegister;